import { useState } from 'react'

import { localStorageService } from '~/@common/services/storage.service'

export const useCasSubmitConfirmSkip = () => {
  const [skip, setSkipState] = useState(() => localStorageService.cas.skipSubmitConfirm)

  const setSkip = (next: boolean) => {
    localStorageService.update({ cas: { skipSubmitConfirm: next } })
    setSkipState(next)
  }

  return { skip, setSkip }
}
